import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import moment from 'moment';
import {
   ChannelName,
   UserProfileImage,
   UserProfileName,
} from '../components';

const InvitationItem = ({ item, isProcessing, onApprove, onDecline }) => {
   const { activityId, name, channelId, createdAt, approved, declined, initiatedBy, updatedBy } = item;

   const formatDate = useCallback(() => {
      if (!createdAt) return '';
      return moment(createdAt).format('MMM DD')
   }, [createdAt]);

   return (
      <div key={activityId} className="invite-item">
         <div className="invite-image">
            <UserProfileImage userId={initiatedBy.userId} />
         </div>

         <div className="invitedetails-overall">
            <div className="invite-details">
               <h3 className="invite-name">
                  <UserProfileName userId={initiatedBy.userId} asText />
                  <span className="invite-date">{formatDate()}</span>
               </h3>
               <div className="invite-email">
                  {!approved && !declined && (
                     <p className="invite-status">
                        Join Request for <ChannelName channelId={channelId} showAnnouncementIcon={false} />
                     </p>
                  )}

                  {approved && (
                     <div className="invite-approved">
                        <span>Joined</span>
                        <span className="invite-channel-name" title={name}>
                           @{name}
                        </span>
                     </div>
                  )}
                  {declined && (
                     <div className="invite-declined">
                        <span>Request Declined</span>
                        <span className="invite-channel-name" title={name}>
                           @{name}
                        </span>
                     </div>
                  )}
                  {approved && (
                     <div className="invite-approved">
                        <span className="invite-status-text" title={`Approved by ${updatedBy?.name}`}>
                           Approved by <UserProfileName userId={updatedBy?.userId} />
                        </span>
                     </div>
                  )}
                  {declined && (
                     <div className='invite-declined'>
                        <span className="invite-status-text" title={`Declined by ${updatedBy?.name}`}>
                           Declined by <UserProfileName userId={updatedBy?.userId} />
                        </span>
                     </div>
                  )}
               </div>
            </div>

            {!approved && !declined && (
               <div className="invite-actions">
                  <button
                     className="btn-decline"
                     onClick={() => onDecline(item)}
                     disabled={isProcessing}
                  >
                     Decline
                  </button>
                  <button
                     className="btn-approve"
                     onClick={() => onApprove(item)}
                     disabled={isProcessing}
                  >
                     Accept
                  </button>
               </div>
            )}
         </div>
      </div>
   );
};

InvitationItem.propTypes = {
   item: PropTypes.shape({
      activityId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      channelId: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      approved: PropTypes.bool.isRequired,
      declined: PropTypes.bool.isRequired,
      initiatedBy: PropTypes.object.isRequired,
      updatedBy: PropTypes.object,
   }).isRequired,
   isProcessing: PropTypes.bool.isRequired,
   onApprove: PropTypes.func.isRequired,
   onDecline: PropTypes.func.isRequired,
};

export default InvitationItem;

